import { TextField, Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../AxiosBaseApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Validation schema
const validationSchema = Yup.object({
  amount: Yup.number().required("Amount is required"),
});

const FundTransfer = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState(""); // Direct amount state

  // Fetch user data
  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
      return;
    }
    const getUserData = async () => {
      try {
        const response = await axiosInstance.get(`/bet.php?action=getuserinfo&user=${token}`);
        if (response.status === 200 && response.data.length > 0) {
          setAmount(response.data[0]?.pmain || ""); // Set amount from API
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.log("Error", error);
      }
    };
    getUserData();
  }, [navigate]);

  // Handle form submission
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const id = localStorage.getItem("mamberId");
      const response = await axiosInstance.post(
        `/bet.php?action=amounttransfer&user=${id}&amount=${values.amount}`
      );
      console.log("response", response);
      if (response.status === 200) {
        toast.success("Amount successfully transferred!");
        setTimeout(() => {
          resetForm();
          navigate("/mian");
        }, 1000);
      } else {
        toast.error("Failed to transfer. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.log("Error", error);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          padding: 1,
          justifyContent: "space-between",
          alignItems: "center",
          background: "#3d3b6f",
        }}
      >
        <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
          <ChevronLeftIcon
            fontSize="medium"
            style={{
              color: "#fff",
              border: "1px solid #f2f3f5",
              borderRadius: 50,
            }}
          />
        </Box>
        <Typography variant="subtitle2" color="#fff">
          Fund Transfer
        </Typography>
        <Box> </Box>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h4" color="secondary.light" gutterBottom sx={{ textAlign: "center" }}>
          Personal Balance To Main Balance
        </Typography>

        {/* Formik Form */}
        <Formik
          enableReinitialize
          initialValues={{
            amount: amount, // Yeh state se lega
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form
              style={{
                background: "#fff",
                borderRadius: "10px",
                padding: "10px",
                width: "80%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* Amount Field - Disabled */}
              <TextField
                label="Amount"
                name="amount"
                size="small"
                variant="outlined"
                value={values.amount}
                fullWidth
                type="number"
                disabled // User can't edit
                sx={{ marginBottom: 2 }}
              />

              {/* Submit Button */}
              <Button variant="contained" type="submit" sx={{ color: "#fff" }}>
                Transfer Amount
              </Button>
            </Form>
          )}
        </Formik>

        {/* Toast Notifications */}
        <ToastContainer />
      </Box>
    </div>
  );
};

export default FundTransfer;
